import { Reducer } from 'redux';
import { MassageTherapyActionTypes, MassageTherapyState } from './type';

const initialState: MassageTherapyState = {
  shopInfo: {
    id: -1,
    shopImageList: [],
    shopName: '',
    districtName: '',
    districtAddress: '',
    shopDesc: '',
    shopStatus: '',
    businessDate: '',
    businessHours: '',
    productList: [],
  },
  productInfo: {
    id: -1,
    productCode: '',
    productName: '',
    productRealPrice: 0,
    productPrice: 0,
    duration: 0,
    remark: '',
    extInfoList: [],
    productImage: '',
  },
};

const reducer: Reducer<MassageTherapyState> = (state = initialState, action) => {
  switch (action.type) {
    case MassageTherapyActionTypes.SELECT_SHOP: {
      const { data } = action;
      return {
        ...state,
        shopInfo: data,
      };
    }
    case MassageTherapyActionTypes.SELECT_PRODUCT: {
      const { data } = action;
      return {
        ...state,
        productInfo: data,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as MassageTherapyReducer };
